var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4069_16647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.26394 12.8316C10.7224 12.8316 12.7153 10.8386 12.7153 8.38015C12.7153 5.92171 10.7224 3.92871 8.26394 3.92871C5.8055 3.92871 3.8125 5.92171 3.8125 8.38015C3.8125 10.8386 5.80544 12.8316 8.26388 12.8316",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50865 6.1929C2.17657 5.61769 1.78623 5.014 1.33765 4.38184C0.635382 5.59792 0.265649 6.97747 0.265625 8.38176C0.265601 9.78606 0.635288 11.1656 1.33752 12.3817C2.03974 13.5978 3.04976 14.6076 4.26602 15.3096C5.48228 16.0116 6.86192 16.381 8.26621 16.3806C9.00251 15.3479 9.50242 14.6034 9.76596 14.1469C10.2721 13.2701 10.9268 12.0149 11.7299 10.3812V10.3803C11.379 10.9886 10.8742 11.4938 10.2661 11.8451C9.65804 12.1964 8.96819 12.3814 8.26593 12.3816C7.56367 12.3817 6.87376 12.1969 6.26558 11.8457C5.6574 11.4946 5.15239 10.9896 4.80134 10.3813C3.71059 8.34709 2.94636 6.9509 2.50865 6.1929Z",
    fill: "#229342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26706 16.3803C9.31766 16.3805 10.358 16.1737 11.3287 15.7717C12.2993 15.3697 13.1813 14.7805 13.9241 14.0376C14.667 13.2947 15.2562 12.4127 15.6581 11.442C16.0601 10.4713 16.2668 9.43097 16.2666 8.38037C16.2663 6.97606 15.8963 5.59657 15.1939 4.38056C13.6784 4.23118 12.5599 4.15649 11.8385 4.15649C11.0205 4.15649 9.82983 4.23118 8.2665 4.38056L8.26562 4.38118C8.9679 4.38083 9.65788 4.56541 10.2662 4.91636C10.8745 5.2673 11.3797 5.77223 11.7309 6.38037C12.0821 6.98851 12.267 7.67841 12.267 8.38069C12.267 9.08297 12.0821 9.77287 11.7308 10.381L8.26706 16.3803Z",
    fill: "#FBC116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26844 11.5479C10.0174 11.5479 11.4352 10.13 11.4352 8.38099C11.4352 6.63192 10.0174 5.21411 8.26837 5.21411C6.51944 5.21411 5.10156 6.63199 5.10156 8.38099C5.10156 10.13 6.51944 11.5479 8.26844 11.5479Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26394 4.38089H15.1912C14.4893 3.16461 13.4795 2.15458 12.2633 1.45237C11.0472 0.750162 9.66763 0.38052 8.26332 0.380615C6.85902 0.38071 5.47949 0.750539 4.26345 1.45291C3.04741 2.15529 2.03773 3.16545 1.33594 4.38182L4.79962 10.3812L4.80056 10.3817C4.44916 9.77367 4.26404 9.08383 4.26384 8.38156C4.26363 7.67929 4.44834 6.98935 4.79939 6.38111C5.15043 5.77288 5.65544 5.2678 6.26363 4.91666C6.87181 4.56553 7.56173 4.38072 8.264 4.38082L8.26394 4.38089Z",
    fill: "#E33B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4069_16647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.265625 0.380615)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.61fb4d1360686031080a38b496c55acf.svg";
export { ForwardRef as ReactComponent };